import "./style.scss";

import logotipo_svg from "../../assets/logotipo-alta.png";

export const Header = () => (
  <div className="header">
    <p>
      <img src={logotipo_svg} alt="logotipo" />
    </p>
    <h1>Comunidade de Empreendedores</h1>
  </div>
);
